import { useNavigate } from "react-router-dom";
import React, { useRef, useState, useEffect } from "react";
import logo from "../assets/logo.png";
import icon from "../assets/Icon.png";
import nr from "../assets/Nr.png";
import down from "../assets/Down.svg";
import right from "../assets/Right.svg";
import { toast, ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import trans from "../assets/Transport.svg";
import twit from "../assets/Twit.png";
import asset from "../assets/Asset.svg";
import gate from "../assets/Gate.svg";
import sign from "../assets/Sign.svg";
import dock from "../assets/Dock.svg";
import Ar from "../assets/Ar.svg";
import bus from "../assets/Bus.png";
import q from "../assets/Q.png";
import tg from "../assets/Tick.png";
import bbb from "../assets/BBB.png";
import n from "../assets/N.png";
import img1 from "../assets/IMG1.png";
import img2 from "../assets/IMG2.png";
import img3 from "../assets/IMG3.png";
import tii from "../assets/TII.png";
import banner from "../assets/Banner.png";
import i1 from "../assets/I1.png";
import ios from "../assets/IOS.png";
import iosgreen from "../assets/IOSgreen.png";
import pc from "../assets/PC.png";
import pcgreen from "../assets/PCgreen.png";
import playStore from "../assets/Playstore.png";
import appStore from "../assets/Appstore.png";
import load from "../assets/Load.png";
import android from "../assets/Android.png";
import o1 from "../assets/O1.png";
import riarr from "../assets/Rightarr.svg";
import o2 from "../assets/O2.png";
import o3 from "../assets/O3.png";
import o4 from "../assets/O4.png";
import { Link } from "react-router-dom";
import o5 from "../assets/O5.png";
import news from "../assets/News.png";
import mail from "../assets/Mail.png";
import insta from "../assets/Insta.png";
import face from "../assets/Facebook.png";
import youtube from "../assets/Youtube.png";
import link from "../assets/Link.png";
import phone from "../assets/Phone.png";
import ee from "../assets/Email.png";
import trial from "../assets/Trial.png";
import newsgreen from "../assets/Newsgreen.png";
import androidgreen from "../assets/Androidgreen.png";
import s1 from "../assets/S1.png";
import s2 from "../assets/S2.png";
import s3 from "../assets/S3.png";
import s4 from "../assets/S4.png";
import s5 from "../assets/S5.png";
import close from "../assets/Close.png";
const Gate = () => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState("Products");
   const [hovered, setHovered] = useState(false);
     const [hoveredItem, setHoveredItem] = useState(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  

   const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };



  const [hoveredCard, setHoveredCard] = useState(null);
  const [hoveredIndex1, setHoveredIndex1] = useState(null);
    const days = ["TUE", "WED", "THU", "FRI", "SAT", "SUN", "MON"];
    
      const [hoveredIndex, setHoveredIndex] = useState(0);
    
  const timeSlotsTopRow = [
    "06:00 AM",
    "06:30 AM",
    "07:00 AM",
    "08:00 AM",
    "07:30 AM",
  ];
  const timeSlotsBottomRow = ["09:30 AM", "10:00 AM"];
  
    const cardStyle = (isHovered) => ({
      border: isHovered ? "2px dashed #1D4ED8" : "2px dashed #E5E5E5",
      borderRadius: "12px",
      padding: "12px",
      backgroundColor: isHovered ? "#F5FAFF" : "#fff",
      display: "inline-block",
      whiteSpace: "nowrap",
      transition: "all 0.3s ease",
      cursor: "pointer",
    });
  
    const titleStyle = {
      fontSize: "14px",
      color: "#000",
      fontWeight: "600",
      fontFamily: "Epilogue",
      whiteSpace: "nowrap",
    };
  
    const descStyle = {
      fontSize: "12px",
      color: "#6B7280",
    };

    const getTimeStyle = (isHovered) => ({
    padding: "6px 12px",
    border: `1px solid ${isHovered ? "#004BA8" : "#E5E7EB"}`,
    borderRadius: "6px",
    fontSize: "12px",
    color: isHovered ? "#004BA8" : "#111827",
    backgroundColor: isHovered ? "#E6F0FA" : "#fff",
    cursor: "pointer",
    minWidth: "70px",
    textAlign: "center",
    fontWeight: "500",
    transition: "all 0.2s ease",
  });

   const sections = [
    {
      label: "Afternoon",
      times: ["01:00 PM", "01:30 PM", "02:00 PM", "02:30 PM"],
    },
    {
      label: "Evening",
      times: ["05:00 PM", "05:30 PM", "06:00 PM", "06:30 PM"],
    },
    {
      label: "Night",
      times: ["08:00 PM", "08:30 PM", "09:00 PM", "09:30 PM"],
    },
  ];


   const getSlotStyle = (isHovered) => ({
    padding: "6px 12px",
    border: `1px solid ${isHovered ? "#004BA8" : "#E5E7EB"}`,
    borderRadius: "6px",
    fontSize: "12px",
    color: isHovered ? "#004BA8" : "#111827",
    backgroundColor: isHovered ? "#E6F0FA" : "#fff",
    cursor: "pointer",
    minWidth: "70px",
    textAlign: "center",
    fontWeight: "500",
    transition: "all 0.2s ease",
  });



  const handleClick = (item) => {
    setActiveItem(item);

    if (item === "Products") {
      setShowDropdown(!showDropdown);
    } else {
      setShowDropdown(false);
    }

    if (item === "Pricing") {
      navigate("/new");
    }

    if (item === "Home") {
      navigate("/");
    }

    if (item === "Say Hello") {
      navigate("/contact");
    }

    if (item === "Partner") {
      navigate("/part");
    }
  };
  const complianceData = [
    { icon: o1, title: "General Data Protection" },
    { icon: o2, title: "SOC2 Compliance Report" },
    { icon: o3, title: "Data Processing Agreement" },
    { icon: o4, title: "ISO Certification" },
    { icon: o5, title: "VAPT Compliance" },
  ];
  const policyRoutes = {
    "Terms and Conditions": "/terms",
    "Privacy Policy": "/privacy",
    "Cookie Policy": "/cookies",
    "Copyright Policy": "/copyright",
  };
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownItems = [
    {
      title: "LOGISTICS OPERATIONS",
      items: [
   {
  icon: gate,
  name: "Gate",
  description: (
    <>
      Helps organizations track and manage
      <br />
      visitors efficiently.
    </>
  ),
}

        // {
        //   icon: dock,
        //   name: "Dock",
        //   description:
        //     "Helps businesses streamline loading, unloading & scheduling.",
        // },
        // {
        //   icon: sign,
        //   name: "Signage",
        //   description:
        //     "Creating, managing & displaying digital content on screens.",
        // },
      ],
    },
    // {
    //   title: "TRACKING SYSTEM",
    //   items: [
    //     // {
    //     //   icon: trans,
    //     //   name: "Transport",
    //     //   description:
    //     //     "Helps users efficiently manage & optimize transportation services.",
    //     // },
    //     // {
    //     //   icon: bus,
    //     //   name: "Vehicle Management",
    //     //   description:
    //     //     "Tracks vehicles, optimizes routes, and automates expenses.",
    //     // },
    //     // {
    //     //   icon: asset,
    //     //   name: "Asset",
    //     //   description:
    //     //     "Helps businesses track, monitor, and manage assets efficiently.",
    //     // },
    //   ],
    // },
    {
      title: "WORKFORCE MANAGEMENT",
      items: [
        {
  icon: q,
  name: "MeetQ",
  description: (
    <>
      Book & manage meeting rooms
      <br />
      with real-time tracking.
    </>
  ),
}

        // {
        //   icon: tg,
        //   name: "TickGo",
        //   description: "Track tasks, log hours, and update statuses.",
        // },
        // {
        //   icon: n,
        //   name: "Nexus",
        //   description: "Manage attendance, tasks, and productivity.",
        // },
      ],
    },
  ];
  const cardsRef = useRef([]);
  const [activeIndex, setActiveIndex] = useState(0);


  

  const cardData = [
    {
      title: "Enhanced Security",
      description:
        "By strictly regulating and monitoring entry and departure points, gate management considerably strengthens the security of commercial buildings.",
      image: s1,
    },
    {
      title: "Enhanced Access Control",
      description:
        "Companies can set up exact access control rules that guarantee that only vehicles or authorized individuals are able to enter designated zones at predetermined times.",
      image: s2,
    },
    {
      title: "Streamlined Operations",
      description:
        "Gate reduces the administrative burden usually associated with manual gate management by automating entrance and exit procedures, which speeds up operations. It also boosts productivity.",
      image: s3,
    },
    {
      title: "Real-Time Visibility",
      description:
        "Businesses can monitor entry and exit events in real-time, gaining instantaneous visibility into gate activity. This visibility makes it easier to react quickly to security events.",
      image: s4,
    },
    {
      title: "Data-Driven Intelligence",
      description:
        "Through close examination of this data, companies can identify patterns, optimize gate operations, and make well-informed choices to improve overall security posture and operational effectiveness.",
      image: s5,
    },
  ];
  const [scrolledDown, setScrolledDown] = useState(false);

useEffect(() => {
  const handleScroll = () => {
    setScrolledDown(window.scrollY > 100); // adjust value as needed
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = Number(entry.target.getAttribute("data-index"));
            setActiveIndex(index);
          }
        });
      },
      { threshold: 0.5 }
    );

    cardsRef.current.forEach((card) => card && observer.observe(card));
    return () => observer.disconnect();
  }, []);

  const [activeIndexx, setActiveIndexx] = useState(0);
  const cardsReff = useRef([]);
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Trigger when half of card is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const index = Number(entry.target.dataset.index);
        if (entry.isIntersecting) {
          setActiveIndexx(index);
        }
      });
    }, observerOptions);

    cardsReff.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);


   const [isMobileOrTablet, setIsMobileOrTablet] = useState(
    window.innerWidth <= 768
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobileOrTablet(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  const isMobile = screenWidth <= 768;
  const isTablet = screenWidth > 768 && screenWidth <= 1024;
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [mobileProductsOpen, setMobileProductsOpen] = useState(false);


     const [isMobileOrTablett, setIsMobileOrTablett] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 1024 : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobileOrTablett(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  
 const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };

   const canvasRef = useRef(null);
    const [captchaValue, setCaptchaValue] = useState(""); // text from API
    const [userCaptcha, setUserCaptcha] = useState("");
  
    /* ------------------------------------------------------------------- API fetch */
    const fetchCaptcha = async () => {
      try {
        const res = await fetch(
          "https://api-uat.mawalog.com/admin/v2/api/website"
        );
        const json = await res.json();
        setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
      } catch (err) {
        console.error("Error fetching captcha:", err);
      }
    };
  
    /* -- fetch once on mount ------------------------------------------------------- */
    useEffect(() => {
      fetchCaptcha();
    }, []);
  
    /* -- redraw every time captchaValue changes ------------------------------------ */
    useEffect(() => {
      if (!data) return; // nothing to paint yet
      const canvas = canvasRef.current;
      if (!canvas) return;
  
      const ctx = canvas.getContext("2d");
      const W = canvas.width;
      const H = canvas.height;
  
      /* ========= clear & background */
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, W, H);
  
      /* ========= random faint bezier curves (extra distortion) */
      for (let i = 0; i < 3; i++) {
        ctx.beginPath();
        ctx.moveTo(Math.random() * W, Math.random() * H);
        ctx.bezierCurveTo(
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H
        );
        ctx.lineWidth = 1 + Math.random(); // 1-2 px
        ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
        ctx.stroke();
      }
  
      /* ========= characters (uneven) */
      ctx.font = "bold 22px Arial";
      ctx.fillStyle = "#0A3A72";
      const chars = data.toString().split("");
  
      chars.forEach((ch, i) => {
        const angle = (Math.random() - 0.5) * 0.8; // ±23°
        const x = 8 + i * 14 + (Math.random() * 4 - 2);
        const y = 22 + (Math.random() * 6 - 3);
  
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.fillText(ch, 0, 0);
        ctx.restore();
      });
  
      /* ========= dots */
      for (let i = 0; i < 45; i++) {
        ctx.beginPath();
        ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
        ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
        ctx.fill();
      }
    }, [data]);
  
    /* -- reload button click ------------------------------------------------------- */
    const handleReload = () => {
      fetch("https://api-uat.mawalog.com/admin/v2/api/website")
        .then((response) => response.json())
        .then((json) => {
          setData(json.data.captcha_code);
          setSessionid(json.data.session_id);
          setToken(json.data.token);
        })
        .catch((error) => console.error("Error fetching data:", error));
    };
  
  const handleSubscribe = async () => {
    try {
      const response = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": token,
          },
          body: JSON.stringify({
            session_id: sessionid,
            captcha: userCaptcha,
            email: email,
            type: "Mawalog",
          }),
        }
      );

      const result = await response.json();
      console.log("Response:", userCaptcha, " ", data);
      setEmail("");
     setUserCaptcha("");
      toast(result.message);
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };


  const location = useLocation();

  // Scroll to the hash section on mount or hash change
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.getElementById(location.hash.replace("#", ""));
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);
  
  return (
    <div>
         <ToastContainer
    position="bottom-right"
    autoClose={3000}
    style={{ bottom: "80px" }}
  />
      {/* <div
        style={{
          position: "fixed",
          bottom: "5%",
          right: "4%",
          zIndex: 9999,
        }}
        className="floating-button-container"
      >
        <button
          style={{
            padding: 0,
            background: "transparent",
            border: "none",
            cursor: "pointer",
          }}
        >
          <img
            src={icon}
            alt="button icon"
            className="floating-button-icon"
            style={{
              width: "12vw",
              height: "12vw",
              maxWidth: "50px",
              maxHeight: "50px",
            }}
          />
        </button>

        <style>{`
    .floating-button-container {
      transition: all 0.3s ease;
    }

    .floating-button-icon {
      transition: width 0.3s ease, height 0.3s ease;
    }

    @media screen and (max-width: 768px) {
      .floating-button-container {
        bottom: 6%;
        right: 5%;
      }
      .floating-button-icon {
        width: 10vw;
        height: 10vw;
        max-width: 45px;
        max-height: 45px;
      }
    }

    @media screen and (max-width: 480px) {
      .floating-button-container {
        bottom: 8%;
        right: 6%;
      }
      .floating-button-icon {
        width: 9vw;
        height: 9vw;
        max-width: 40px;
        max-height: 40px;
      }
    }
  `}</style>
      </div> */}

<>
        <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    top: 0,
    zIndex: 1000,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: isMobile ? "10px 3%" : "0px 5%",
    backgroundColor: "#fff",
    flexWrap: "wrap",
     borderBottom: "1px solid #ddd",
  }}
>

<div
  onClick={() => {
    if (window.location.pathname === "/") {
      window.location.reload();
    } else {
      window.location.href = "/";
    }
  }}
  style={{ cursor: "pointer" }}
>
  <img
    src={logo}
    alt="Logo"
    style={{
      maxWidth: isMobile ? "120px" : "150px",
      height: "auto",
      marginLeft: isMobile ? "-10px" : "-50px",
    }}
  />
</div>

   
           {/* Mobile Hamburger Icon */}
           {isMobile && (
             <button
               onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
               style={{ background: "none", border: "none", cursor: "pointer" }}
             >
               <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                 <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
               </svg>
             </button>
           )}
   
           {/* Desktop/Tablet Menu */}
           {!isMobile && (
             <div
               style={{
                 display: "flex",
                 alignItems: "center",
                 gap: "8px",
                 flexDirection: "row",
                 width: "auto",
                 backgroundColor: "transparent",
                 padding: "0",
               }}
             >
{["Products", "Partner", "Say Hello"].map((item, index) => (
        <div
          key={index}
          style={{ position: "relative", width: "auto" }}
          onMouseEnter={() => {
            setHoveredItem(item);
            if (item === "Products") setShowDropdown(true);
          }}
          onMouseLeave={() => {
            setHoveredItem(null);
            if (item === "Products") setShowDropdown(false);
          }}
        >
          <div
            onClick={() => handleClick(item)}
            style={{
              fontSize: "clamp(12px, 2vw, 16px)",
              cursor: "pointer",
              fontWeight: "normal",
              backgroundColor:
                activeItem === item || hoveredItem === item
                  ? "#EAF3FF"
                  : "transparent",
              padding: "8px 16px",
              borderRadius: "20px",
              transition: "background-color 0.3s",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              justifyContent: "flex-start",
            }}
          >
            {item}
            {item === "Products" && (
              <img
                src={down}
                alt="Down Arrow"
                style={{
                  width: "10px",
                  height: "7px",
                  transform: showDropdown ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s",
                }}
              />
            )}
          </div>

          {item === "Products" && showDropdown && (
            <div
              onMouseEnter={() => setShowDropdown(true)}
              onMouseLeave={() => setShowDropdown(false)}
              style={{
                position: "fixed",
                top: 30,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 9999,
                marginTop: "20px",
                backgroundColor: "#FFFFFF",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                borderRadius: "24px",
                overflow: "hidden",
                width: "min(980px, 90vw)",
                maxWidth: "100%",
                padding: "16px",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: "16px",
                boxSizing: "border-box",
              }}
            >
              {dropdownItems.map((section, i) => (
                <div
                  key={i}
                  style={{
                    paddingRight:
                      i < dropdownItems.length - 1 ? "16px" : undefined,
                    borderRight:
                      i < dropdownItems.length - 1
                        ? "1px solid #E0E0E0"
                        : "none",
                  }}
                >
                  <div
                    style={{
                      color: "#666",
                      fontWeight: 600,
                      marginBottom: 12,
                      textTransform: "uppercase",
                      fontSize: 12,
                    }}
                  >
                    {section.title}
                  </div>

                  {section.items.map((product, j) => (
                    <div
                      key={j}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 10,
                        padding: "8px",
                        cursor: "pointer",
                        marginBottom: 8,
                        borderRadius: 8,
                        transition: "background-color 0.3s ease",
                      }}
                      onClick={() => {
                        if (product.name === "Gate") navigate("/gate");
                        else if (product.name === "MeetQ") navigate("/meetq");
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#F0F8FF";
                        const name = e.currentTarget.querySelector(
                          ".product-name"
                        );
                        const arrow = e.currentTarget.querySelector(".arrow-icon");
                        if (name) name.style.color = "#004aad";
                        if (arrow) {
                          arrow.style.filter =
                            "brightness(0) saturate(100%) invert(17%) sepia(99%) saturate(746%) hue-rotate(197deg) brightness(94%) contrast(100%)";
                          arrow.style.transform = "translateX(4px)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        const name = e.currentTarget.querySelector(
                          ".product-name"
                        );
                        const arrow = e.currentTarget.querySelector(".arrow-icon");
                        if (name) name.style.color = "inherit";
                        if (arrow) {
                          arrow.style.filter = "none";
                          arrow.style.transform = "translateX(0)";
                        }
                      }}
                    >
                      <img
                        src={product.icon}
                        alt={product.name}
                        style={{ width: 20, height: 20 }}
                      />
                      <div>
                        <div
                          className="product-name"
                          style={{
                            fontWeight: 600,
                            display: "flex",
                            alignItems: "center",
                            transition: "color 0.3s ease",
                            fontSize: 13,
                          }}
                        >
                          {product.name}
                          <img
                            className="arrow-icon"
                            src={nr}
                            alt="arrow"
                            style={{
                              marginLeft: 4,
                              width: 16,
                              height: 16,
                              transition: "filter 0.3s ease, transform 0.3s ease",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            color: "#666",
                            fontSize: 12,
                            textAlign: "left",
                            lineHeight: 1.4,
                          }}
                        >
                          {product.description}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}

   
               <div style={{ display: "flex", justifyContent: "end", gap: "8px" }}>
                 <button
  onClick={() => window.open("http://app.mawalog.com/login", "_blank")}
  className="login-button"
  style={{
    padding: "10px 20px",
    borderRadius: "20px",
    border: "1px solid #004aad",
    backgroundColor: "#fff",
    color: "#004aad",
    fontWeight: "bold",
    cursor: "pointer",
    fontSize: "16px",
    transition: "background-color 0.3s",
  }}
  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
>
  Login
</button>

                 <button
                   onClick={() => window.open("https://app.mawalog.com/register", "_blank")}
                   className="register-button"
                   style={{
                     padding: "10px 20px",
                     borderRadius: "20px",
                     border: "none",
                     backgroundColor: "#004aad",
                     color: "#fff",
                     fontWeight: "bold",
                     cursor: "pointer",
                     fontSize: "16px",
                     transition: "background-color 0.3s",
                   }}
                   onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                   onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
                 >
                   Register
                 </button>
               </div>
             </div>
           )}
         </div>
   
         {/* Mobile Menu */}
         {isMobile && isMobileMenuOpen && (
           <div
             style={{
               position: "fixed",
               top: 0,
               left: 0,
               width: "100%",
               height: "100%",
               backgroundColor: "#fff",
               padding: "20px",
               overflowY: "auto",
               zIndex: 1001,
               boxSizing: "border-box",
               fontFamily: "Epilogue, sans-serif",
             }}
           >
             {/* Header with Logo and Close Button */}
             <div
               style={{
                 display: "flex",
                 justifyContent: "space-between",
                 alignItems: "center",
                 marginBottom: "20px",
               }}
             >
               <Link to="/">
  <img
    src={logo}
    alt="Logo"
    style={{ width: "120px", height: "auto", cursor: "pointer" }}
  />
</Link>
               <button
                 onClick={() => setIsMobileMenuOpen(false)}
                 style={{ background: "none", border: "none", cursor: "pointer" }}
               >
                 <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                 </svg>
               </button>
             </div>
   
             {/* Navigation Items */}
             {["Products", "Partner", "Say Hello"].map((item, index) => (
               <div key={index} style={{ marginBottom: "12px", width: "100%" }}>
                 {item === "Products" ? (
                   <>
                     <div
                       onClick={() => setMobileProductsOpen(!mobileProductsOpen)}
                       style={{
                         fontSize: "16px",
                         cursor: "pointer",
                         fontWeight: "600",
                         color: "#004aad",
                         padding: "12px",
                         display: "flex",
                         justifyContent: "center",
                         alignItems: "center",
                         borderRadius: "8px",
                         transition: "background-color 0.3s",
                         textAlign: "center",
                       }}
                       onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                       onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                     >
                       Products
                       <img
                         src={down}
                         alt="Arrow"
                         style={{
                           width: "10px",
                           height: "7px",
                           transform: mobileProductsOpen ? "rotate(180deg)" : "rotate(0deg)",
                           transition: "transform 0.3s",
                         }}
                       />
                     </div>
                     {mobileProductsOpen && (
                       <div
                         style={{
                           marginTop: "12px",
                           padding: "16px",
                           backgroundColor: "#F9FAFB",
                           borderRadius: "12px",
                           display: "flex",
                           flexDirection: "column",
                           gap: "16px",
                           maxWidth: "100%",
                           overflow: "auto",
                           boxSizing: "border-box",
                           justifyContent: "center",
                           alignItems: "center",
                           textAlign: "center",
                         }}
                       >
                         {dropdownItems.map((section, i) => (
                           <div key={i} style={{ marginBottom: "16px", width: "100%", maxWidth: "90%" }}>
                             <div
                               style={{
                                 color: "#666",
                                 fontWeight: "600",
                                 textTransform: "uppercase",
                                 fontSize: "12px",
                                 marginBottom: "8px",
                               }}
                             >
                               {section.title}
                             </div>
                             {section.items.map((product, j) => (
                               <div
                                 key={j}
                                 style={{
                                   display: "flex",
                                   flexDirection: "column",
                                   alignItems: "center",
                                   gap: "8px",
                                   padding: "8px",
                                   cursor: "pointer",
                                   borderRadius: "8px",
                                   transition: "background-color 0.3s ease",
                                   maxWidth: "100%",
                                 }}
                                 onClick={() => {
                                   if (product.name === "Gate") navigate("/gate");
                                   else if (product.name === "MeetQ") navigate("/meetq");
                                   setIsMobileMenuOpen(false);
                                 }}
                                 onMouseEnter={(e) => {
                                   e.currentTarget.style.backgroundColor = "#F0F8FF";
                                   const name = e.currentTarget.querySelector(".product-name");
                                   name.style.color = "#004aad";
                                 }}
                                 onMouseLeave={(e) => {
                                   e.currentTarget.style.backgroundColor = "transparent";
                                   const name = e.currentTarget.querySelector(".product-name");
                                   name.style.color = "inherit";
                                 }}
                               >
                                 <img src={product.icon} alt={product.name} style={{ width: "20px", height: "20px" }} />
                                 <div style={{ flex: 1, overflow: "hidden" }}>
                                   <div
                                     className="product-name"
                                     style={{
                                       fontWeight: "600",
                                       fontSize: "14px",
                                       transition: "color 0.3s ease",
                                       whiteSpace: "normal",
                                       overflow: "hidden",
                                       textOverflow: "ellipsis",
                                       textAlign: "center",
                                     }}
                                   >
                                     {product.name}
                                   </div>
                                   <div
                                     style={{
                                       color: "#666",
                                       fontSize: "12px",
                                       lineHeight: "1.4",
                                       overflowWrap: "break-word",
                                       textAlign: "center",
                                     }}
                                   >
                                     {product.description}
                                   </div>
                                 </div>
                               </div>
                             ))}
                           </div>
                         ))}
                         <a
                           href="#"
                           style={{
                             color: "#004aad",
                             fontWeight: "600",
                             fontSize: "14px",
                             textDecoration: "none",
                             display: "inline-flex",
                             alignItems: "center",
                             padding: "8px",
                           }}
                           onClick={() => setIsMobileMenuOpen(false)}
                         >
                           Explore all products
                           <img
                             src={right}
                             alt="arrow"
                             style={{
                               marginLeft: "4px",
                               width: "16px",
                               height: "16px",
                               verticalAlign: "middle",
                             }}
                           />
                         </a>
                       </div>
                     )}
                   </>
                 ) : (
                   <div
                     onClick={() => {
                       handleClick(item);
                       setIsMobileMenuOpen(false);
                     }}
                     style={{
                       fontSize: "16px",
                       cursor: "pointer",
                       fontWeight: "600",
                       color: "#004aad",
                       padding: "12px",
                       borderRadius: "8px",
                       transition: "background-color 0.3s",
                       textAlign: "center",
                     }}
                     onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                     onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                   >
                     {item}
                   </div>
                 )}
               </div>
             ))}
   
             {/* Buttons */}
             <div
               style={{
                 display: "flex",
                 flexDirection: "column",
                 gap: "12px",
                 width: "100%",
                 marginTop: "20px",
               }}
             >
               <button
                 onClick={() => {
                   window.location.href = "http://app.mawalog.com/login";
                   setIsMobileMenuOpen(false);
                 }}
                 style={{
                   padding: "8px 16px",
                   borderRadius: "20px",
                   border: "1px solid #004aad",
                   backgroundColor: "#fff",
                   color: "#004aad",
                   fontWeight: "bold",
                   cursor: "pointer",
                   fontSize: "14px",
                   width: "100%",
                   transition: "background-color 0.3s",
                 }}
                 onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
                 onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
               >
                 Login
               </button>
               <button
                 onClick={() => {
                   window.open("https://app.mawalog.com/register", "_blank");
                   setIsMobileMenuOpen(false);
                 }}
                 style={{
                   padding: "8px 16px",
                   borderRadius: "20px",
                   border: "none",
                   backgroundColor: "#004aad",
                   color: "#fff",
                   fontWeight: "bold",
                   cursor: "pointer",
                   fontSize: "14px",
                   width: "100%",
                   transition: "background-color 0.3s",
                 }}
                 onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                 onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
               >
                 Register
               </button>
             </div>
           </div>
         )}
   
         {/* Media Queries for Tablet Button Size */}
         <style>
           {`
             @media (min-width: 769px) and (max-width: 1024px) {
               .login-button, .register-button {
                 padding: 8px 16px !important;
                 font-size: 14px !important;
               }
             }
           `}
         </style>
       </>
   

<div
  style={{
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px clamp(16px, 4vw, 30px)",
    fontFamily: "sans-serif",
    backgroundColor: "#fff",
    position: "sticky",
    top: 0,
    zIndex: 999,
  }}
>
  {/* Left: Logo + Nav in one block */}
  <div
    style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "clamp(20px, 5vw, 40px)",
      flexWrap: "wrap",
      flexGrow: 1, // fill available space
      minWidth: 0,
    }}
  >
    {/* Logo */}
 <a href="/gate" style={{ textDecoration: "none" }}>
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      cursor: "pointer",
    }}
  >
    <img
      src={gate}
      alt="Gate Logo"
      style={{ width: "32px", height: "32px", marginBottom: "10px" }}
    />
    <span
      style={{
        fontSize: "clamp(24px, 5vw, 30px)",
        fontWeight: 800,
        color: "#1A1A1A",
        whiteSpace: "nowrap",
        marginBottom: "10px",
      }}
    >
      Gate
    </span>
  </div>
</a>


    {/* Nav Links */}
    <nav
      style={{
        display: "flex",
        gap: "clamp(12px, 4vw, 30px)",
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: "center",
      }}
    >
      {[
        { href: "/industries", text: "Industries Served" },
        { href: "/features", text: "Features" },
        { href: "/price", text: "Pricing" },
        { href: "/faq", text: "FAQ" },
      ].map(({ href, text }) => (
        <a
          key={text}
          href={href}
          style={{
            fontFamily: "Epilogue",
            fontSize: "clamp(13px, 2.2vw, 16px)",
            fontWeight: 400,
            textDecoration: "none",
            color: "#1A1A1A",
            cursor: "pointer",
            lineHeight: 1.4,
          }}
        >
          {text}
        </a>
      ))}
    </nav>
  </div>

  {/* Right: Button stays aligned right */}
  <div
    style={{
      flex: "0 0 auto",
      marginLeft: "auto", // pushes it to the right even if wrapped
      marginTop: "10px", // space if it wraps below nav
    }}
  >
    <button
      onClick={() =>
        window.open(
          "https://outlook.office365.com/book/MawalogOne@lenteratechno.onmicrosoft.com/",
          "_blank"
        )
      }
      style={{
        backgroundColor: "#2E8B57",
        color: "#fff",
        padding: "clamp(8px, 1.5vw, 12px) clamp(16px, 6vw, 20px)",
        fontSize: "clamp(12px, 2vw, 14px)",
        fontWeight: 600,
        borderRadius: 9999,
        border: "none",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        whiteSpace: "nowrap",
      }}
    >
      Book a Demo
      <img
        src={bbb}
        alt="arrow"
        style={{
          width: "clamp(14px, 3.5vw, 18px)",
          height: "clamp(14px, 3.5vw, 18px)",
        }}
      />
    </button>

    
  </div>
</div>



 <div
      style={{
        fontFamily: "Epilogue, sans-serif",
        textAlign: "center",
        padding: "clamp(40px, 8vw, 80px) 20px",
        backgroundColor: "#fff",
      }}
    >
      {/* ────────────── Title */}
      <div style={{ fontSize: "clamp(28px, 6vw, 44px)", fontWeight: 700, color: "#1A1A1A", marginBottom: "clamp(16px, 4vw, 24px)", lineHeight: 1.2 }}>
        Revolutionizes security<br />and efficiency
      </div>

      {/* ────────────── Subtitle */}
      <div style={{ fontSize: "clamp(15px, 2.8vw, 18px)", maxWidth: "min(90%, 700px)", margin: "0 auto clamp(20px, 4vw, 32px)", color: "#555", lineHeight: 1.6 }}>
        Our innovative Gate feature revolutionizes security and efficiency by seamlessly integrating with smooth operations from entry to exit.
      </div>

      {/* ────────────── Centered Button */}
<>
  {/* Button */}
  <div className="demo-button-wrapper">
    <button
      onClick={toggleSlider}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`book-demo-btn ${isHovered ? "hovered" : ""}`}
    >
      Book a demo
      <div className={`arrow-container ${isHovered ? "arrow-animate" : ""}`}>
        <img
          src={Ar}
          alt="Arrow Icon"
          className="arrow-icon"
          style={{ marginTop: "4px" }}
        />
      </div>
    </button>
  </div>

  {/* Sliding Panel */}
  <div className={`sliding-panel ${isOpen ? "open" : ""}`}>
    <button
      onClick={toggleSlider}
      style={{ float: "right", marginBottom: "10px" }}
    >
      ❌
    </button>
    <iframe
      src="https://outlook.office365.com/book/MawalogOne@lenteratechno.onmicrosoft.com/"
      title="Book a Demo"
      style={{
        width: "100%",
        height: "90vh",
        border: "none",
      }}
    ></iframe>
  </div>

  {/* CSS styles */}
  <style>{`
    .demo-button-wrapper {
      width: 100%;
      display: flex;
      justify-content: center;
    }

    .book-demo-btn {
      background-color:#2C8C53;
      color: white;
      padding: 10px 20px;
      font-size: 16px;
      border: none;
      border-radius: 50px;
      cursor: pointer;
      display: flex;
      align-items: center;
    }

    .book-demo-btn.hovered {
      background-color: #1C6539;
    }

    .sliding-panel {
      position: fixed;
      top: 0;
      right: 0;
      height: 100%;
      width: 50%;
      max-width: 600px;
      background-color: #fff;
      transform: translateX(100%);
      transition: transform 0.4s ease-in-out;
      z-index: 1000;
      overflow-y: auto;
      padding: 20px;
      box-sizing: border-box;
      box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
    }

    .sliding-panel.open {
      transform: translateX(0);
    }

    @media (max-width: 768px) {
      .sliding-panel {
        width: 100%;
      }
    }

    .arrow-container {
      display: inline-block;
      margin-left: 8px;
    }

    .arrow-icon {
      width: 12px;
      height: 12px;
      transition: transform 0.3s;
    }

    .arrow-animate .arrow-icon {
      transform: translateX(5px);
    }

    .vision-text {
      text-align: left;
    }

    @media (max-width: 991px) {
      div[style*="font-family: Epilogue"][style*="font-weight: 700"] {
        margin-bottom: 12px !important;
      }

      .vision-text {
        margin-top: 0;
      }
    }
  `}</style>

  {/* Overlay when panel is open */}
  {isOpen && (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        zIndex: 999,
        display: "flex",
        justifyContent: "flex-end",
      }}
      onClick={() => setIsOpen(false)}
    >
      <div onClick={(e) => e.stopPropagation()}>
        <div
          style={{
            maxWidth: "800px",
            margin: "0 auto",
            padding: "30px 20px",
            fontFamily: "sans-serif",
          }}
        ></div>
      </div>
    </div>
  )}
</>



    </div>

 <div
      style={{
        fontFamily: "Epilogue, sans-serif",
        backgroundColor: "#fff",
        padding: "clamp(20px, 4vw, 60px) 15px",
        borderRadius: "20px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
        maxWidth: "1000px",
        margin: "0 auto",
      }}
    >
      {/* Header Row */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          alignItems: "flex-start",
          marginBottom: isMobileOrTablett ? "12px" : "clamp(16px, 3vw, 40px)",
          rowGap: "12px",
        }}
      >
        <div
          style={{
            fontFamily: "Epilogue",
            marginTop: isMobileOrTablett ? "0" : "-25px",
            fontSize: "clamp(18px, 4vw, 32px)",
            fontWeight: "700",
            color: "#1A1A1A",
            flex: "1 1 300px",
            minWidth: "180px",
          }}
        >
          Optimizing security
          <br />
          and efficiency
        </div>
        <div
          style={{
            fontFamily: "Epilogue",
            flex: "1 1 300px",
            fontSize: "clamp(12px, 2vw, 16px)",
            color: "#555",
            lineHeight: "1.5",
            marginTop: isMobileOrTablett ? "0" : "-25px",
            minWidth: "180px",
          }}
        >
          Our smart gate management system enhances operational flow by
          streamlining access control, reducing bottlenecks, and ensuring
          secure, efficient movement across your facility.
        </div>
      </div>

      {/* Card Row */}
      <div
        style={{
          display: "flex",
          gap: "clamp(8px, 2vw, 24px)",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {[
          {
            img: img1,
            title: "Access control",
            desc: "Feature that helps manage who can enter a facility, when, and where they can go.",
          },
          {
            img: img2,
            title: "Security upgrade",
            desc: "Enhancing the system’s ability to prevent unauthorized access, monitor visitor activity.",
          },
          {
            img: img3,
            title: "Operation efficiency",
            desc: "Helps streamline processes, reduce manual work, and improve the overall speed and accuracy.",
          },
        ].map((card, i) => (
          <div
            key={i}
            style={{
              flex: "1 1 250px",
              minWidth: "clamp(160px, 45%, 280px)",
              maxWidth: "320px",
              textAlign: "center",
            }}
          >
            <div style={{ padding: "clamp(8px, 2vw, 20px)" }}>
              <img
                src={card.img}
                alt={card.title}
                style={{ width: "100%", height: "auto" }}
              />
            </div>
            <div
              style={{
                fontFamily: "Epilogue",
                fontWeight: "500",
                fontSize: "clamp(14px, 3vw, 18px)",
                textAlign: "left",
                marginLeft: "16px",
                color: "#1A1A1A",
                marginBottom: "6px",
              }}
            >
              {card.title}
            </div>
            <div
              style={{
                fontFamily: "Epilogue",
                fontSize: "clamp(10px, 2vw, 12px)",
                textAlign: "left",
                marginLeft: "16px",
                color: "#777",
                lineHeight: "1.5",
              }}
            >
              {card.desc}
            </div>
          </div>
        ))}
      </div>
    </div>








  <div
  style={{
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
    backgroundColor: "#fff",
    borderRadius: "20px",
    margin: "clamp(40px, 8vw, 80px) auto", // responsive vertical margin
    padding: "clamp(30px, 6vw, 60px) clamp(15px, 5vw, 40px)", // responsive padding
    boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
    border: "1px solid #E0E0E0",
    fontFamily: "Epilogue, sans-serif",
    maxWidth: "970px",
    gap: "clamp(20px, 5vw, 40px)", // responsive gap between left & right
  }}
  className="core-gate-container"
>
  {/* Left Section */}
  <div style={{ flex: "1 1 400px", minWidth: "280px", maxWidth: "100%" }} className="left-section">
    <h2
      style={{
        fontFamily: "Epilogue",
        fontSize: "clamp(24px, 5vw, 36px)",
        fontWeight: "600",
        color: "#1A1A1A",
        marginBottom: "clamp(12px, 3vw, 20px)",
      }}
    >
      Core function of Gate
    </h2>
    <p
      style={{
        fontSize: "clamp(12px, 2vw, 14px)",
        color: "#555",
        lineHeight: "1.6",
        marginBottom: "clamp(20px, 4vw, 30px)",
      }}
    >
      Tracking and managing all visitors—employees, contractors, delivery
      personnel, and guests—entering a facility. It helps enhance
      security, improve visitor experience, and maintain accurate records.
    </p>

    {/* Bullet List */}
    {[
      "Comprehensive Solution",
      "Contemporary Access Control Systems",
      "Limit Access To Permitted Individuals",
      "Advanced Reporting",
      "Analytics Capabilities",
      "Proactive Decision-Making",
      "Maximize Security Protocols",
      "Risk Management",
    ].map((item, index) => (
      <div
        key={index}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          fontSize: "clamp(12px, 2vw, 14px)",
          color: "#1A1A1A",
          marginBottom: "clamp(8px, 2vw, 12px)",
        }}
      >
        <div
          style={{
            width: "24px",
            height: "24px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
          }}
        >
          <img
            src={tii}
            alt="check"
            style={{
              width: "20px",
              height: "20px",
              objectFit: "contain",
            }}
          />
        </div>

        <span>{item}</span>
      </div>
    ))}
  </div>

  {/* Right Section with Image */}
  <div
    style={{
      flex: "1 1 500px",
      minWidth: "300px",
      maxWidth: "100%",
      textAlign: "center",
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
    className="right-section"
  >
    <img
      src={banner}
      alt="Gate visitor list"
      style={{
        width: "120%",
        maxWidth: "900px",
        height: "auto",
        marginLeft: "clamp(10px, 2vw, 60px)",
        borderRadius: "16px",
        objectFit: "contain",
      }}
      className="gate-banner"
    />
  </div>

  <style>{`
    /* Tablet and smaller */
    @media (max-width: 1024px) {
      .core-gate-container {
        max-width: 100% !important;
        margin: clamp(20px, 5vw, 40px) 10px !important;
        padding: clamp(20px, 4vw, 40px) clamp(10px, 3vw, 30px) !important;
      }
      .left-section {
        min-width: 220px !important;
        flex: 1 1 45% !important;
      }
      .right-section {
        min-width: 220px !important;
        flex: 1 1 45% !important;
      }
      .gate-banner {
        width: 100% !important;
        max-width: 100% !important;
        margin-left: 0 !important;
      }
    }

    /* Mobile */
    @media (max-width: 480px) {
      .core-gate-container {
        flex-direction: column !important;
        gap: clamp(20px, 5vw, 30px) !important;
        margin: clamp(10px, 3vw, 20px) 10px !important;
        padding: clamp(10px, 3vw, 20px) 10px !important;
      }
      .left-section,
      .right-section {
        min-width: 100% !important;
        flex: 1 1 100% !important;
      }
      .gate-banner {
        width: 100% !important;
        max-width: 100% !important;
        margin-left: 0 !important;
      }
    }
  `}</style>
</div>



 <div
  style={{
    marginTop: "50px",
    backgroundColor: "#222222",
    padding: "clamp(30px, 5vw, 60px) clamp(15px, 5vw, 40px)",
    fontFamily: "sans-serif",
    color: "#ffffff",
    boxSizing: "border-box",
    width: "100%",
  }}
  className="gate-functions-container"
>
  <div
    style={{
      fontFamily: "Epilogue",
      fontSize: "clamp(20px, 4vw, 40px)",
      marginBottom: "clamp(20px, 4vw, 40px)",
      fontWeight: "600",
      lineHeight: "1.3",
    }}
    className="gate-functions-title"
  >
    Functions of <br />
    Gate
  </div>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "clamp(12px, 3vw, 20px)",
      width: "100%",
      boxSizing: "border-box",
    }}
    className="gate-functions-grid"
  >
    {[...Array(4)].map((_, index) => (
      <div
        key={index}
        style={{
          backgroundColor: "#2A2A2A",
          padding: "clamp(16px, 3vw, 24px)",
          borderRadius: "12px",
          color: "#D1D1D1",
          boxSizing: "border-box",
        }}
        className="gate-functions-card"
      >
        <div style={{ marginBottom: "clamp(12px, 3vw, 16px)" }} className="gate-functions-icon">
          <img
            src={i1}
            alt="icon"
            style={{ width: "clamp(30px, 5vw, 42px)", height: "clamp(30px, 5vw, 42px)" }}
          />
        </div>
        <div
          style={{
            fontSize: "clamp(16px, 3vw, 18px)",
            fontWeight: "700",
            color: "#ffffff",
            fontFamily: "Epilogue",
          }}
          className="gate-functions-header"
        >
          {
            [
              "Vehicle Registration",
              "Document Verification",
              "Tracking Information",
              "Security Measurement",
            ][index]
          }
        </div>
        <div
          style={{
            fontSize: "clamp(12px, 2vw, 14px)",
            marginTop: "clamp(6px, 2vw, 8px)",
            fontFamily: "Epilogue",
            lineHeight: "1.5",
          }}
          className="gate-functions-text"
        >
          {
            [
              "Essential information such as license plate numbers, driver details, and information.",
              "Shipping documents, invoices, and permits associated with incoming and outgoing shipments.",
              "Shipments in real-time, from entry to exit, providing visibility and control over the entire supply chain.",
              "Encryption, firewalls, intrusion detection to protect the platform from access.",
            ][index]
          }
        </div>
      </div>
    ))}
  </div>

  {/* Responsive CSS */}
  <style>{`
    /* Laptop and Desktop (default) - keep as is */

    /* Tablets (width up to 1024px) */
    @media (max-width: 1024px) {
      .gate-functions-container {
        padding: clamp(25px, 4vw, 50px) clamp(10px, 4vw, 30px);
      }
      .gate-functions-title {
        font-size: clamp(18px, 5vw, 36px);
        margin-bottom: clamp(15px, 4vw, 30px);
      }
      .gate-functions-grid {
        gap: clamp(10px, 3vw, 16px);
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
      }
      .gate-functions-card {
        padding: clamp(14px, 3vw, 20px);
      }
      .gate-functions-icon img {
        width: clamp(28px, 5vw, 36px);
        height: clamp(28px, 5vw, 36px);
      }
      .gate-functions-header {
        font-size: clamp(15px, 3vw, 16px);
      }
      .gate-functions-text {
        font-size: clamp(11px, 2vw, 13px);
        margin-top: clamp(5px, 2vw, 6px);
      }
    }

    /* Mobile (width up to 480px) */
    @media (max-width: 480px) {
      .gate-functions-container {
        padding: clamp(20px, 5vw, 40px) clamp(10px, 5vw, 20px);
      }
      .gate-functions-title {
        font-size: clamp(16px, 6vw, 30px);
        margin-bottom: clamp(12px, 5vw, 24px);
      }
      .gate-functions-grid {
        grid-template-columns: 1fr; /* single column on mobile */
        gap: clamp(10px, 4vw, 18px);
      }
      .gate-functions-card {
        padding: clamp(12px, 4vw, 20px);
      }
      .gate-functions-icon img {
        width: clamp(25px, 6vw, 34px);
        height: clamp(25px, 6vw, 34px);
      }
      .gate-functions-header {
        font-size: clamp(14px, 4vw, 16px);
      }
      .gate-functions-text {
        font-size: clamp(11px, 3vw, 13px);
        margin-top: clamp(4px, 3vw, 6px);
      }
    }
  `}</style>
</div>


     <div
  style={{
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start",
    backgroundColor: "#F7F9FA",
    padding: "clamp(30px, 6vw, 60px) clamp(15px, 5vw, 80px)",
    gap: "clamp(20px, 5vw, 40px)",
  }}
  className="recommend-gate-container"
>
  {/* Left Section (Sticky) */}
  <div
    style={{
      maxWidth: "520px",
      width: "100%",
      position: "sticky",
      top: "80px",
      alignSelf: "flex-start",
      flex: "1 1 300px",
      minWidth: "280px",
    }}
    className="recommend-gate-left"
  >
    <h2
      style={{
        fontFamily: "Epilogue",
        fontSize: "clamp(22px, 5vw, 42px)",
        fontWeight: "600",
        marginBottom: "clamp(16px, 3vw, 24px)",
        color: "#1A1A1A",
      }}
      className="recommend-gate-title"
    >
      Why we recommend Gate for a business
    </h2>
    <div
      style={{
        fontFamily: "Epilogue",
        fontSize: "clamp(12px, 2.5vw, 14px)",
        lineHeight: "1.6",
        color: "#6B7280",
        marginBottom: "clamp(20px, 4vw, 32px)",
      }}
      className="recommend-gate-description"
    >
      We offer powerful reasons to grow your business wisely for <br />
      smarter decisions, sustainable success, and lasting <br />
      profitability.
    </div>

    {/* Progress Bar - hidden on mobile and tablet */}
    {!isMobileOrTablet && (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "clamp(8px, 2vw, 12px)",
          fontFamily: "",
        }}
        className="recommend-gate-progress"
      >
        {[0, 1, 2, 3, 4].map((index) => (
          <div
            key={index}
            style={{
              width: "clamp(12px, 3vw, 20px)",
              height: "6px",
              borderRadius: "4px",
              backgroundColor:
                activeIndex === index ? "#1DAD61" : "#D1D5DB",
              transition: "background-color 0.3s ease",
            }}
          ></div>
        ))}
        <span
          style={{
            fontSize: "clamp(12px, 2vw, 14px)",
            color: "#1A1A1A",
            marginLeft: "8px",
            whiteSpace: "nowrap",
          }}
        >
          {activeIndex + 1}/5
        </span>
      </div>
    )}
  </div>

  {/* Right Section (Scrolls) */}
  <div
    style={{
      flex: "1 1 400px",
      width: "100%",
      paddingBottom: 0,
      display: "flex",
      justifyContent: "center",
    }}
    className="recommend-gate-right"
  >
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "clamp(12px, 3vw, 20px)",
        width: "100%",
        maxWidth: "480px",
      }}
      className="recommend-gate-cards"
    >
      {cardData.map((card, index) => {
        const isLast = index === cardData.length - 1;

        return (
          <div
            key={index}
            data-index={index}
            ref={(el) => (cardsRef.current[index] = el)}
            style={{
              position: isLast ? "static" : "sticky",
              top: isLast ? "auto" : "130px",
              zIndex: activeIndex === index ? 10 : index,
              transition: "transform 0.5s ease-in-out",
              transform:
                activeIndex === index ? "translateY(0)" : "translateY(10px)",
              backgroundColor: "#FFFFFF",
              borderRadius: "16px",
              padding: "clamp(16px, 3vw, 22px)",
              display: "flex",
              flexDirection: "column",
              gap: "clamp(12px, 3vw, 16px)",
              boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.05)",
              width: "90%",
              maxWidth: "480px",
            }}
            className="recommend-gate-card"
          >
            <img
              src={card.image}
              alt={card.title}
              style={{
                width: "clamp(24px, 5vw, 30px)",
                height: "clamp(24px, 5vw, 30px)",
              }}
            />
            <div
              style={{
                fontSize: "clamp(16px, 3vw, 20px)",
                fontWeight: "700",
                color: "#1A1A1A",
                fontFamily: "Epilogue",
              }}
            >
              {card.title}
            </div>
            <div
              style={{
                fontSize: "clamp(12px, 2vw, 14px)",
                color: "#4B5563",
                lineHeight: "1.6",
                fontFamily: "Epilogue",
              }}
            >
              {card.description}
            </div>
          </div>
        );
      })}
    </div>
  </div>

  {/* Responsive CSS */}
  <style>{`
    /* Laptop & Desktop (default) */

    /* Tablets (max-width: 1024px) */
    @media (max-width: 1024px) {
      .recommend-gate-container {
        padding: clamp(25px, 5vw, 50px) clamp(10px, 4vw, 50px);
        gap: clamp(15px, 4vw, 30px);
      }
      .recommend-gate-left {
        max-width: 420px;
        flex: 1 1 280px;
        min-width: 240px;
        top: 60px; /* slightly smaller sticky offset */
      }
      .recommend-gate-title {
        font-size: clamp(20px, 6vw, 38px);
        margin-bottom: clamp(14px, 3vw, 22px);
      }
      .recommend-gate-description {
        font-size: clamp(11px, 2.5vw, 13px);
        margin-bottom: clamp(16px, 4vw, 28px);
      }
      .recommend-gate-progress div {
        width: clamp(10px, 3vw, 18px);
        height: 5px;
      }
      .recommend-gate-progress span {
        font-size: clamp(11px, 2vw, 13px);
      }
      .recommend-gate-right {
        flex: 1 1 350px;
      }
      .recommend-gate-cards {
        max-width: 400px;
        gap: clamp(10px, 3vw, 18px);
      }
      .recommend-gate-card {
        padding: clamp(14px, 3vw, 20px);
        width: 95%;
        max-width: 400px;
      }
      .recommend-gate-card img {
        width: clamp(22px, 5vw, 28px) !important;
        height: clamp(22px, 5vw, 28px) !important;
      }
      .recommend-gate-card div:first-child {
        font-size: clamp(15px, 3vw, 18px);
      }
      .recommend-gate-card div:last-child {
        font-size: clamp(11px, 2vw, 13px);
      }
    }

    /* Mobile (max-width: 480px) */
    @media (max-width: 480px) {
      .recommend-gate-container {
        padding: clamp(20px, 6vw, 40px) clamp(10px, 5vw, 30px);
        gap: clamp(12px, 5vw, 20px);
        flexDirection: "column"; /* stack vertically */
      }
      .recommend-gate-left {
        position: "static" !important; /* disable sticky on mobile */
        max-width: 100%;
        min-width: 100%;
        flex: 1 1 100%;
        top: 0 !important;
        marginBottom: clamp(20px, 4vw, 30px);
      }
      .recommend-gate-title {
        font-size: clamp(18px, 7vw, 32px);
        margin-bottom: clamp(12px, 4vw, 20px);
      }
      .recommend-gate-description {
        font-size: clamp(10px, 3vw, 12px);
        margin-bottom: clamp(12px, 4vw, 20px);
      }
      .recommend-gate-progress {
        display: none; /* hide progress bar on mobile */
      }
      .recommend-gate-right {
        flex: 1 1 100%;
        justifyContent: "flex-start";
      }
      .recommend-gate-cards {
        max-width: 100%;
        gap: clamp(10px, 4vw, 18px);
      }
      .recommend-gate-card {
        position: "static" !important; /* disable sticky */
        padding: clamp(12px, 4vw, 18px);
        width: 100%;
        max-width: 100%;
      }
      .recommend-gate-card img {
        width: clamp(20px, 6vw, 26px) !important;
        height: clamp(20px, 6vw, 26px) !important;
      }
      .recommend-gate-card div:first-child {
        font-size: clamp(14px, 4vw, 16px);
      }
      .recommend-gate-card div:last-child {
        font-size: clamp(10px, 3vw, 12px);
      }
    }
  `}</style>
</div>


  <div
  style={{
    fontFamily: "Epilogue, sans-serif",
    maxWidth: "1000px",
    margin: "0 auto",
    marginTop: isMobileOrTablet ? "20px" : "50px",
    padding: isMobileOrTablet ? "30px 15px" : "60px 20px",
    border: "1px solid #e0e0e0",
    borderRadius: "16px",
    marginBottom: "60px", // 👈 Prevents touching the next section
  }}
>
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      marginBottom: isMobileOrTablet ? "20px" : "40px",
      gap: isMobileOrTablet ? "10px" : undefined,
    }}
  >
    <div
      style={{
        flex: "1 1 300px",
        fontSize: isMobileOrTablet ? "24px" : "32px",
        fontWeight: "600",
        color: "#1A1A1A",
        marginBottom: isMobileOrTablet ? "10px" : "20px",
      }}
    >
      Download the <br />
      Gate App
    </div>
    <div
      style={{
        flex: "2 1 400px",
        fontSize: isMobileOrTablet ? "12px" : "14px",
        color: "#555",
        lineHeight: "1.6",
      }}
    >
      Stay ahead in evolving business landscapes with agile communication
      strategies that enable quick adaptation, foster resilience, and keep
      your organization aligned, informed, and ready to seize new
      opportunities.
    </div>
  </div>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: isMobileOrTablet ? "10px" : "20px",
    }}
  >
    {/* Android */}
    <a
      href="https://play.google.com/store/apps/details?id=com.mawalog.gate"
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "inherit", display: "block" }}
    >
      <div
        style={{
          backgroundColor: isHovered ? "#E6FFEE" : "#f9f9f9",
          borderRadius: "12px",
          padding: isMobileOrTablet ? "12px" : "24px",
          textAlign: "left",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div style={{ display: "flex", marginBottom: isMobileOrTablet ? "8px" : "16px" }}>
          <img
            src={isHovered ? androidgreen : android}
            alt="android"
            style={{ width: isMobileOrTablet ? "40px" : "50px", height: isMobileOrTablet ? "40px" : "50px" }}
          />
        </div>

        <div style={{ fontSize: isMobileOrTablet ? "11px" : "13px", color: "#808080", marginBottom: "4px" }}>
          Mobile Phone/ Tablet
        </div>

        <div
          style={{
            fontSize: isMobileOrTablet ? "14px" : "18px",
            fontWeight: "600",
            color: isHovered ? "#22A45D" : "#1A1A1A",
            marginBottom: "8px",
            transition: "color 0.3s ease",
          }}
        >
          Android
        </div>

        <div
          style={{
            fontSize: isMobileOrTablet ? "11px" : "13px",
            color: "#555",
            marginBottom: isMobileOrTablet ? "8px" : "16px",
            lineHeight: "1.2",
          }}
        >
          Click on the play store logo for navigate to the download page
        </div>

        <img src={playStore} alt="Google Play" style={{ height: "40px" }} />
      </div>
    </a>

    {/* iOS */}
    <a
      href="https://apps.apple.com/us/app/gate-m/id6477543461"
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "inherit", display: "block" }}
    >
      <div
        style={{
          backgroundColor: isHovered1 ? "#E6FFEE" : "#f9f9f9",
          borderRadius: "12px",
          padding: isMobileOrTablet ? "12px" : "24px",
          textAlign: "left",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={() => setIsHovered1(true)}
        onMouseLeave={() => setIsHovered1(false)}
      >
        <div style={{ display: "flex", marginBottom: isMobileOrTablet ? "8px" : "16px" }}>
          <img
            src={isHovered1 ? iosgreen : ios}
            alt="ios"
            style={{ width: isMobileOrTablet ? "40px" : "50px", height: isMobileOrTablet ? "40px" : "50px" }}
          />
        </div>

        <div style={{ fontSize: isMobileOrTablet ? "11px" : "13px", color: "#808080", marginBottom: "4px" }}>
          Mobile Phone/ Tablet
        </div>

        <div
          style={{
            fontSize: isMobileOrTablet ? "14px" : "18px",
            fontWeight: "600",
            color: isHovered1 ? "#22A45D" : "#1A1A1A",
            marginBottom: "8px",
            transition: "color 0.3s ease",
          }}
        >
          iOS
        </div>

        <div
          style={{
            fontSize: isMobileOrTablet ? "11px" : "13px",
            color: "#555",
            marginBottom: isMobileOrTablet ? "8px" : "16px",
            lineHeight: "1.2",
          }}
        >
          Click on the app store logo for navigate to the download page
        </div>

        <img src={appStore} alt="App Store" style={{ height: "40px" }} />
      </div>
    </a>

    {/* PC / Mac */}
    <a
      href="https://s3.ap-south-1.amazonaws.com/gate.mawalog.com/apps/Gate.exe"
      download
      style={{ textDecoration: "none", color: "inherit", display: "block" }}
    >
      <div
        style={{
          backgroundColor: isHovered2 ? "#E6FFEE" : "#f9f9f9",
          borderRadius: "12px",
          padding: isMobileOrTablet ? "12px" : "24px",
          textAlign: "left",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={() => setIsHovered2(true)}
        onMouseLeave={() => setIsHovered2(false)}
      >
        <div style={{ display: "flex", marginBottom: isMobileOrTablet ? "8px" : "16px" }}>
          <img
            src={isHovered2 ? pcgreen : pc}
            alt="desktop"
            style={{ width: isMobileOrTablet ? "40px" : "50px", height: isMobileOrTablet ? "40px" : "50px" }}
          />
        </div>

        <div style={{ fontSize: isMobileOrTablet ? "11px" : "13px", color: "#808080", marginBottom: "4px" }}>
          Desktop
        </div>

        <div
          style={{
            fontSize: isMobileOrTablet ? "14px" : "18px",
            fontWeight: "600",
            color: isHovered2 ? "#22A45D" : "#1A1A1A",
            marginBottom: "8px",
            transition: "color 0.3s ease",
          }}
        >
          PC / MAC
        </div>

        <div
          style={{
            fontSize: isMobileOrTablet ? "11px" : "13px",
            color: "#555",
            marginBottom: isMobileOrTablet ? "8px" : "16px",
            lineHeight: "1.2",
          }}
        >
          Click on the download button to initiate the downloading process
        </div>

        <button
          style={{
            backgroundColor: "#22A45D",
            color: "#fff",
            border: "none",
            borderRadius: "25px",
            padding: "10px 24px",
            fontSize: "14px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <img
            src={load}
            alt="Download"
            style={{ width: "18px", height: "18px", objectFit: "contain" }}
          />
          Download
        </button>
      </div>
    </a>
  </div>
</div>


   {/* <div
                 style={{
                   fontFamily: "Epilogue",
                   lineHeight: "1.4",
                   padding: "clamp(30px, 5vw, 60px)",
                   marginTop: screenWidth <= 1024 ? "clamp(20px, 4vw, 40px)" : "0",
                 }}
               >
                 <div
                   style={{
                     maxWidth: "clamp(800px, 90vw, 1200px)",
                     margin: "0 auto",
                   }}
                 >
                   <div
                     style={{
                       display: "flex",
                       flexDirection: "column",
                       alignItems: "center",
                     }}
                   >
                     <div
                       style={{
                         color: "#181835",
                         fontSize: "clamp(18px, 2.5vw, 22px)",
                         fontWeight: "bold",
                         paddingLeft: screenWidth <= 1440 ? "clamp(50px, 10vw, 110px)" : "clamp(100px, 12vw, 170px)",
                         alignSelf: "flex-start",
                       }}
                     >
                       Compliance of our company
                     </div>
                     <div
                       style={{
                         display: "flex",
                         justifyContent: "center",
                         gap: "clamp(10px, 2vw, 15px)",
                         marginTop: "clamp(15px, 2vw, 20px)",
                         flexWrap: "wrap",
                       }}
                     >
                       {complianceData.slice(0, 3).map((item, index) => (
                         <div
                           key={index}
                           style={{
                             display: "flex",
                             alignItems: "center",
                             backgroundColor: "#F4F7FF",
                             width: "clamp(200px, 30vw, 270px)",
                             height: "clamp(35px, 5vw, 40px)",
                             padding: "clamp(4px, 1vw, 5px)",
                             borderRadius: "30px",
                             justifyContent: "space-between",
                             cursor: "pointer",
                             transition: "background-color 0.3s, transform 0.3s ease",
                             marginBottom: screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                           }}
                           onMouseEnter={(e) => {
                             e.currentTarget.style.backgroundColor = "#EDF4FF";
                             e.currentTarget.style.transform = "scale(1.03)";
                           }}
                           onMouseLeave={(e) => {
                             e.currentTarget.style.backgroundColor = "#F4F7FF";
                             e.currentTarget.style.transform = "scale(1)";
                           }}
                         >
                           <div style={{ display: "flex", alignItems: "center" }}>
                             <div
                               style={{
                                 borderRadius: "50%",
                                 padding: "clamp(8px, 1.5vw, 10px)",
                                 marginRight: "clamp(8px, 1.5vw, 12px)",
                               }}
                             >
                               <img
                                 src={item.icon}
                                 alt={item.title}
                                 style={{
                                   width: "clamp(30px, 4vw, 40px)",
                                   height: "clamp(30px, 4vw, 40px)",
                                 }}
                               />
                             </div>
                             <span
                               style={{
                                 color: "#181835",
                                 fontSize: "clamp(10px, 1.5vw, 12px)",
                                 marginRight: "-10px",
                               }}
                             >
                               {item.title}
                             </span>
                           </div>
                           <img
                             src={riarr}
                             alt="Arrow"
                             style={{
                               width: "clamp(14px, 2vw, 18px)",
                               height: "clamp(14px, 2vw, 18px)",
                             }}
                           />
                         </div>
                       ))}
                     </div>
                   </div>
                   <div
                     style={{
                       display: "flex",
                       justifyContent: "center",
                       gap: "clamp(10px, 2vw, 15px)",
                       marginTop: "clamp(15px, 2vw, 20px)",
                       flexWrap: "wrap",
                       marginRight: screenWidth <= 1024 ? "clamp(5px, 2vw, 10px)" : "clamp(100px, 20vw, 290px)",
                     }}
                   >
                     {complianceData.slice(3, 5).map((item, index) => (
                       <div
                         key={index}
                         style={{
                           display: "flex",
                           alignItems: "center",
                           backgroundColor: "#F4F7FF",
                           width: "clamp(200px, 30vw, 270px)",
                           height: "clamp(35px, 5vw, 40px)",
                           padding: "clamp(4px, 1vw, 5px)",
                           borderRadius: "30px",
                           justifyContent: "space-between",
                           cursor: "pointer",
                           transition: "background-color 0.3s, transform 0.3s ease",
                           marginBottom: screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                         }}
                         onMouseEnter={(e) => {
                           e.currentTarget.style.backgroundColor = "#EDF4FF";
                           e.currentTarget.style.transform = "scale(1.03)";
                         }}
                         onMouseLeave={(e) => {
                           e.currentTarget.style.backgroundColor = "#F4F7FF";
                           e.currentTarget.style.transform = "scale(1)";
                         }}
                       >
                         <div style={{ display: "flex", alignItems: "center" }}>
                           <div
                             style={{
                               borderRadius: "50%",
                               padding: "clamp(8px, 1.5vw, 10px)",
                               marginRight: "clamp(8px, 1.5vw, 12px)",
                             }}
                           >
                             <img
                               src={item.icon}
                               alt={item.title}
                               style={{
                                 width: "clamp(30px, 4vw, 40px)",
                                 height: "clamp(30px, 4vw, 40px)",
                               }}
                             />
                           </div>
                           <span
                             style={{
                               color: "#181835",
                               fontSize: "clamp(10px, 1.5vw, 12px)",
                               marginRight: "-10px",
                             }}
                           >
                             {item.title}
                           </span>
                         </div>
                         <img
                           src={riarr}
                           alt="Arrow"
                           style={{
                             width: "clamp(14px, 2vw, 18px)",
                             height: "clamp(14px, 2vw, 18px)",
                           }}
                         />
                       </div>
                     ))}
                   </div>
                 </div>
               </div> */}

   <div
           style={{
             fontFamily: "Epilogue",
             lineHeight: "1.4",
             display: "flex",
             alignItems: "center",
             marginTop: "-20px",
             justifyContent: "center",
             backgroundColor: "#2C8C53",
             padding: "clamp(20px, 3vw, 40px) clamp(40px, 5vw, 90px)",
             color: "#fff",
           }}
           className="newsletter-section"
         >
           <div
             style={{
               marginRight: "clamp(20px, 3vw, 40px)",
               marginBottom: "clamp(16px, 2vw, 20px)",
             }}
           >
             <img
               src={newsgreen}
               alt="Newsletter"
               style={{
                 width: "clamp(150px, 20vw, 200px)",
                 height: "clamp(120px, 15vw, 170px)",
                 animation: "floatImage 3s ease-in-out infinite",
               }}
             />
           </div>
   
           <style>
             {`
         @keyframes floatImage {
           0% { transform: translateY(0); }
           50% { transform: translateY(-10px); }
           100% { transform: translateY(0); }
         }
   
         @media (max-width: 480px) {
           .newsletter-section {
             flex-direction: column;
             text-align: center;
             padding: clamp(16px, 3vw, 24px) clamp(16px, 4vw, 24px);
           }
           .newsletter-section > div:first-child {
             margin-right: 0;
             margin-bottom: clamp(16px, 2vw, 20px);
           }
           .newsletter-section h2,
           .newsletter-section p,
           .newsletter-section > div > div,
           .newsletter-section > div > div:last-child {
             margin-left: 0;
           }
           .newsletter-section .newsletter-input {
             min-width: clamp(200px, 80vw, 260px);
           }
           .newsletter-section button {
           
             display: block;
           }
         }
       `}
           </style>
   
           <div className="newsletter-content">
          {/* Title and Paragraph */}
          <>
            <style>
              {`
      .newsletter-text {
        font-family: Epilogue;
        line-height: 1.4;
        font-size: 22px;
        margin-bottom: 10px;
        margin-left: 60px;
      }

      @media (max-width: 1024px) {
        .newsletter-text {
          font-size: 20px;
          margin-left: 50px;
        }
      }

      @media (max-width: 768px) {
        .newsletter-text {
          font-size: 18px;
          margin-left: 40px;
        }
      }

      @media (max-width: 480px) {
        .newsletter-text {
          font-size: 16px;
          margin-left: 30px;
        }
      }
    `}
            </style>

            <div className="newsletter-text">Subscribe to our Newsletter!</div>
          </>

          <>
            <style>
              {`
      .newsletter-description {
        font-size: 14px;
        margin-bottom: 20px;
        text-align: start;
        margin-left: 60px;
        max-width: 100%;
        box-sizing: border-box;
      }

      @media (max-width: 1024px) {
        .newsletter-description {
          font-size: 13px;
          margin-left: 50px;
        }
      }

      @media (max-width: 768px) {
        .newsletter-description {
          font-size: 12.5px;
          margin-left: 40px;
        }
      }

      @media (max-width: 480px) {
        .newsletter-description {
          font-size: 9px; /* reduced more for small screens */
          text-align: center;
      
        }
      }
    `}
            </style>

            <div className="newsletter-description">
              Stay updated with our latest news, offers, and insights! Subscribe{" "}
              <br />
              for exclusive updates delivered straight to your inbox.
            </div>
          </>

          
        <>
  <style>
    {`
      .input-wrapper {
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;
        max-width: 400px;
        margin: 0 auto 10px auto; /* center aligned */
        flex-wrap: nowrap;
      }

      .email-input {
        padding: 14px 16px 14px 48px;
        border-radius: 10px;
        border: 1px solid #9FCAFF;
        outline: none;
        background-color:#1C6539;
        color: #fff;
        flex: 1;
        width: 100%;
        box-sizing: border-box;
        font-size: 16px;
      }

      .email-icon {
        position: absolute;
        left: 16px;
        width: 20px;
        height: 20px;
      }

      /* Optional: Keep consistent appearance on all devices */
      @media (max-width: 480px) {
        .email-input {
          padding: 12px 12px 12px 44px;
          font-size: 14px;
        }
      }
    `}
  </style>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      justifyContent: "center",
    }}
  >
    <div className="input-wrapper">
      <img src={mail} alt="Email Icon" className="email-icon" />
      <input
        type="email"
        value={email}
        placeholder="sample@gmail.com"
        className="email-input"
        onChange={handleChange}
      />
    </div>
  </div>
</>


         
          <>
            <style>{`
        .captcha-container {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 10px auto !important;
          border-radius: 20px !important;    
          gap: 8px !important;
          flex-wrap: wrap !important;
        }
      .captcha-box {
  width: 60px !important;
  height: 40px !important;
  border-radius: 8px !important;
  background-color: #fff !important;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden !important; /* Add this to clip canvas overflow */
}

#captchaCanvas {
  border-radius: 20px !important;
}
        .captcha-input {
          padding:10px 1px!important;
          border-radius:8px!important;
          border:1px solid #ccc!important;
          outline:none!important;
          min-width:120px!important;
          background:#1C6539!important;
          color:#fff!important;
        }
        .subscribe-button {
          padding:14px 30px!important;
          border-radius:12px!important;
          border:none!important;
          background:#fff!important;
          color:#1C6539!important;
          font-weight:bold!important;
          cursor:pointer!important;
          margin-bottom:0!important;
        }
        @media(max-width:1024px){ .captcha-container{margin-left:50px!important;} .captcha-input{min-width:110px!important;} }
        @media(max-width:768px ){ .captcha-container{margin-left:40px!important;} .captcha-input{min-width:100px!important;} }
        @media(max-width:480px ){ .captcha-container{margin-left:20px!important;margin-right:20px!important;gap:4px!important;} .captcha-input{min-width:80px!important;font-size:14px!important;} }
      `}</style>

            <div className="captcha-container">
              <div className="captcha-box">
                <canvas
                  ref={canvasRef}
                  id="captchaCanvas"
                  width={60}
                  height={40}
                />
              </div>

              <button
                onClick={handleReload}
                style={{
                  background: "#1C6539",
                  color: "#fff",
                  border: "none",
                  padding: "8px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* Your reload SVG icon here */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
              </button>

              <input
                type="text"
                placeholder="Enter captcha"
                value={userCaptcha}
                onChange={(e) => setUserCaptcha(e.target.value)}
                className="captcha-input"
              />

              <button className="subscribe-button" onClick={handleSubscribe}>
                Subscribe
              </button>
            </div>
          </>

          {/* Note */}
          <div
            style={{
              fontSize: "12px",
              marginTop: "10px",
              color: "#fff",
              marginLeft:
                window.innerWidth <= 480
                  ? "20px"
                  : window.innerWidth <= 768
                  ? "40px"
                  : window.innerWidth <= 1024
                  ? "50px"
                  : "60px",
            }}
          >
            *Unsubscribe anytime. We don’t send any spam
          </div>
        </div>
         </div>

     <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    display: "flex",
    justifyContent: "space-between",
    padding: isMobile ? "20px 10px" : "40px",
    backgroundColor: "#fff",
    flexWrap: "wrap",
    maxWidth: "1200px",
    margin: "0 auto",
    boxSizing: "border-box",
  }}
>
  <div
    style={{
      maxWidth: isMobile ? "100%" : isTablet ? "50%" : "300px",
      marginBottom: "40px",
    }}
  >
    <Link to="/">
      <img
        src={logo}
        alt="Mawalog"
        style={{
          width: isMobile ? "150px" : "180px",
          height: "auto",
          display: "flex",
          justifyContent: "start",
          cursor: "pointer"  // shows it's clickable
        }}
      />
    </Link>
    <p
      style={{
        color: "#555",
        fontSize: isMobile ? "12px" : "14px",
        lineHeight: "1.6",
        textAlign: "start",
        marginBottom: isMobile ? "20px" : "100px",
      }}
    >
      At Mawalog, we believe in simplifying the complexities of supply chain
      management by offering an integrated platform that combines manufacturing,
      logistics, and warehouse solutions partner with optimized logistics and a
      global network.
    </p>
    <div
      style={{
        display: "flex",
        gap: "12px",
        marginTop: isMobile ? "0" : "-80px",
      }}
    >
      {[insta, face, youtube, link,twit].map((icon, index) => (
        <img
          key={index}
          src={icon}
          alt={`icon-${index}`}
          style={{
            width: isMobile ? "20px" : "24px",
            height: isMobile ? "20px" : "24px",
            cursor: "pointer",
            transition: "transform 0.3s ease",
            transformOrigin: "center",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.4)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "scale(1)")
          }
          onClick={() => {
            if (icon === face)
              window.open("https://www.facebook.com/mawalogone/", "_blank");
            if (icon === youtube)
              window.open("https://www.youtube.com/@mawalogone", "_blank");
            if (icon === insta)
              window.open("https://www.instagram.com/mawalogone/", "_blank");
            if (icon === link)
              window.open(
                "https://www.linkedin.com/company/mawalogone/",
                "_blank"
              )
              if (icon === twit)
              window.open("https://x.com/mawalogone", "_blank");
          }}
        />
      ))}
    </div>
  </div>

  <div
  style={{
    display: "flex",
    gap: isMobile ? "20px" : isTablet ? "40px" : "60px",
    flexWrap: "wrap",
    justifyContent: isMobile ? "flex-start" : "space-between",
  }}
>
  <div>
    <h4
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "bold",
      }}
    >
      Know More
    </h4>
{["Opportunities", "Articles", "Our Story", "Help Center"].map(
  (item, index) => (
    <p
      key={index}
      style={{
        margin: "8px 0",
        color: "#555",
        cursor: "pointer",
        textAlign: "start",
        fontSize: isMobile ? "12px" : "14px",
        transition: "color 0.3s ease",
        paddingBottom: "2px",
      }}
      onClick={() => {
        switch (item) {
          case "Opportunities":
          case "Articles":
          case "Help Center":
            navigate("/coming");
            break;
          case "Our Story":
            navigate("/about");
            break;
        }
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "#3B82F6";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "#555";
      }}
    >
      {item}
    </p>
  )
)}

  </div>

 <div>
      <h4
        style={{
          fontSize: isMobile ? "12px" : "14px",
          fontWeight: "bold",
          marginRight: isMobile ? "0" : "20px",
        }}
      >
        Legal &amp; Policies
      </h4>

 {[
  "Terms and Conditions",
  "Privacy Policy",
  "Cookie Policy",
  "Copyright Policy",
].map((item, index) => (
  <p
    key={index}
    style={{
      margin: "8px 0",
      color: "#555",
      cursor: "pointer",
      textAlign: "start",
      fontSize: isMobile ? "12px" : "14px",
      transition: "color 0.3s ease",
      paddingBottom: "2px",
    }}
    onClick={() => {
      const targetId = `#${item.toLowerCase().replace(/\s+/g, "-")}`;
      const basePath =
        item === "Terms and Conditions"
          ? "/terms"
          : item === "Privacy Policy"
          ? "/policy"
          : item === "Cookie Policy"
          ? "/cookie"
          : item === "Copyright Policy"
          ? "/copyright"
          : "/";
      navigate(`${basePath}${targetId}`);
    }}
    onMouseEnter={(e) => (e.currentTarget.style.color = "#3B82F6")}
    onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
  >
    {item}
  </p>
))}

    </div>

</div>


  <div style={{ marginBottom: "40px" }}>
    <h4
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "bold",
        marginRight: isMobile ? "0" : "180px",
      }}
    >
      Contact us
    </h4>
    <a
      href="https://mail.google.com/mail/?view=cm&to=info@mawalog.com"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#004BA8",
        cursor: "pointer",
        fontSize: isMobile ? "12px" : "14px",
        textAlign: "start",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <img
        src={ee}
        alt="Email"
        style={{
          width: isMobile ? "12px" : "14px",
          height: isMobile ? "12px" : "14px",
          marginRight: "8px",
        }}
      />
      info@mawalog.com
    </a>
    {[
      { phone: "603-27700-311", country: "Malaysia" },
      { phone: "+971-50-1234567", country: "UAE" },
      { phone: "+44 7911 123456", country: "UK" },
      { phone: "+91-44-4856-3345", country: "India" },
    ].map((contact, index) => (
      <p
        key={index}
        style={{
          fontSize: isMobile ? "12px" : "14px",
          textAlign: "start",
        }}
      >
        <img
          src={phone}
          alt="Phone"
          style={{
            width: isMobile ? "12px" : "14px",
            height: isMobile ? "12px" : "14px",
            marginRight: "8px",
          }}
        />
        <a
          href={`tel:${contact.phone}`}
          style={{
            color: "#004BA8",
            cursor: "pointer",
            textDecoration: "none",
          }}
        >
          {contact.phone}
        </a>{" "}
        (<span style={{ color: "#000" }}>{contact.country}</span>)
      </p>
    ))}
  </div>

  <div
    className="flex flex-col items-center justify-center p-6 rounded-2xl bg-gradient-to-br from-gray-900 to-purple-700 text-white max-w-sm mx-auto shadow-lg"
    style={{ marginBottom: "40px", position: "relative" }}
  >
    <div style={{ position: "relative", display: "inline-block" }}>
      <a
        href="https://app.mawalog.com/register"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={trial}
          alt="Illustration"
          style={{
            width: isMobile ? "180px" : isTablet ? "200px" : "210px",
            height: "auto",
            display: "block",
            cursor: "pointer",
          }}
        />
      </a>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
          pointerEvents: "none",
          zIndex: 2,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "-100%",
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(130deg, transparent 48%, rgba(255,255,255,0.4) 50%, transparent 52%)",
            animation: "shine 3s ease-in-out infinite",
          }}
        ></div>
      </div>
    </div>
    <style>
      {`
        @keyframes shine {
          0% { left: -100%; }
          100% { left: 100%; }
        }
      `}
    </style>
  </div>
</div>

      
              <div
                style={{
                  fontFamily: "Epilogue",
                  lineHeight: "1.4",
                  textAlign: "center",
                  padding: isMobile ? "15px 0" : "20px 0",
                  borderTop: "1px solid #ddd",
                  fontSize: isMobile ? "12px" : "14px",
                  color: "#333",
                }}
              >
                Copyright © 2025. <strong>MAWALOG</strong>. All Rights Reserved
              </div>
    </div>
  );
};

export default Gate;
